import { ChangeDetectionStrategy, Component, inject, Input, OnInit, signal } from '@angular/core';

import { MessagingApiService } from '../../services/messaging-api/messaging-api.service';
import { IMessage } from '../../interfaces/IMessage';

@Component({
  selector: 'ngx-repair-order',
  templateUrl: './repair-order.component.html',
  styleUrls: ['./repair-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RepairOrderComponent implements OnInit {
  private messagingService = inject(MessagingApiService);

  @Input() message: IMessage;
  @Input() idRepairOrder: string;

  error = signal(false);

  ngOnInit(): void {
    if (!this.message.repairOrder) {
      this.getRepairOrder();
    }
  }

  getRepairOrder(): void {
    this.messagingService.getRepairOrder(this.idRepairOrder).subscribe({
      next: (data) => {
        this.message.repairOrder = { ...data.repairOrder, video: data.video ?? '' };
      },
      error: () => {
        this.error.set(true);
      },
    });
  }
}
